var FilesUploader = (function () {

  function _getFileType(file) {
    if (file.type === 'application/pdf')
      return 1;
    if (file.type.match('video/.*'))
      return 2;
    if (file.type.match('image/.*'))
      return 3;
    return 4;
  }

  function _sendFile(fileServiceBaseUrl, file, fileType) {
    const formData = new FormData();
    formData.append('fileData', file);
    const relativeUrl = fileType === 2 ? '/video/' : '/file/';

    return $.ajax({
      type: 'POST',
      url: fileServiceBaseUrl + relativeUrl,
      data: formData,
      processData: false,
      contentType: false
    });
  }

  function _clear($form, field) {
    $form.find('#' + field + '_FileUid').val('');
    $form.find('#' + field + '_FileLink').val('');
    $form.find('#' + field + '_FileName').val('');
    $form.find('#' + field + '_FileType').val('');
    $form.find('#' + field + '_Id').val('');
  };
  
  function _init(fileServiceBaseUrl, $form, field, isRequeredCheckFunction, isTypeAllowedCheckFunction) {

    const inputFileControl = $form.find('#' + field + '_FileInput');

    inputFileControl.find('input[type="file"]')
      .on('change', () => _clear($form, field));

    inputFileControl.find('a.fileinput-exists')
      .on('click', () => _clear($form, field));

    $form.off('submit');
    $form.submit(() => {

      const files = $form.find('#' + field + '_File')[0].files;
      const $error = $form.find('span[data-valmsg-for="' + field + '"]');
      var $fileId = $form.find('#' + field + '_Id');
      var $fileUid = $form.find('#' + field + '_FileUid');
      var $fileName = $form.find('#' + field + '_FileName');
      var $fileType = $form.find('#' + field + '_FileType');
      var $fileLink = $form.find('#' + field + '_FileLink');


        $form.off('change.bs.fileinput clear.bs.fileinput reset.bs.fileinput update.bs.fileinput', '.fileinput');
        $form.on('change.bs.fileinput clear.bs.fileinput reset.bs.fileinput update.bs.fileinput', '.fileinput', function () {
            if (isRequeredCheckFunction() && $(this).hasClass('fileinput-new'))
                $error.html('Обязательное поле');
            else
                $error.html('');
        });

        $form.off('check.validation', '.hidden-validation');
        $form.on('check.validation', '.hidden-validation', function() {
            $(this).valid();
        });

      //Поле ошибки очищаем
      $error.empty();

      var isValid = true;

        //Файл не выбран, но обязателен
      if (files.length === 0 && !$fileUid.val() && isRequeredCheckFunction()) {
          $error.html('Обязательное поле');
          isValid = false;
      }

        var $hiddenValidations = $form.find('.hidden-validation');
        if ($hiddenValidations.length !== 0)
            isValid &= $hiddenValidations.valid();

      //Валидируем форму
      isValid &= $form.valid();

      if (!isValid) {
        $form.error();
        return false;
      }

      //Обрабатываем отправку формы с файлом
      if (files.length > 0) {

        var file = files[0];
        var fileType = _getFileType(file);

        //Проверяем тип файла
        if (!isTypeAllowedCheckFunction(fileType)) {
          $error.html("Неверный тип файла");
          $form.error();
          return false;
        }

        //Отправляем файл, в случае успеха отправляем форму
        _sendFile(fileServiceBaseUrl, file, fileType)
          .done(result => {

            //Обновляем данные о файле в полях
            $fileId.val(''); //Сбрасываем Id, т.к. новый файл
            $fileName.val(file.name);
            $fileUid.val(result.fileUid);
            $fileType.val(fileType);
            if (fileType === 2) {
              $fileLink.val(fileServiceBaseUrl + '/video/' + encodeURIComponent(result.fileUid));
            } else {
              $fileLink.val(fileServiceBaseUrl + '/file/' + encodeURIComponent(result.fileUid));
            }
            //Отправляем форму
            $form._send();
          })
          .fail(() => {
            $error.html('Ошибка загрузки файла на сервер');
            $form.error();
          });

        return false;
      }

      //Отправляем форму без файла
      $form._send();
      return false;
    });
  }

  return {
    initUploadingOnSubmit: _init
  };
}());
